export const ACCESSCODE_PAGE_PREFERENCE = [
    {
        value: 'accessCode',
        text: 'accounts.accessCode.have_accessCode'
    },
    {
        value: 'ssn',
        text: 'accounts.accessCode.have_ssn'
    }
];

export const EDE_SEARCH = (isSearchByNameEnabled) => [
    { value: 'ssn', text: 'selfDesignation.search.radio-option.ssn' },
    ...isSearchByNameEnabled ? [{ value: 'name', text: 'selfDesignation.search.radio-option.name' }] : []
];

export const SELECT_OPTIONS = {
    ACCESSCODE_PAGE_PREFERENCE,
    EDE_SEARCH
};